import React from "react";

// Partículas estáticas — geradas UMA VEZ fora do componente pra não
// recomputar em cada render. Removido filter:blur individual (cada blur
// vira uma GPU layer separada, muito caro com 60 spans).
const WHITE_DOTS = Array.from({ length: 18 }).map((_, i) => ({
    i,
    size: 8 + (i % 8),
    left: (i * 73) % 100,
    top: (i * 41) % 100,
    opacity: 0.18 + ((i % 5) * 0.03),
    dur: 4.5 + (i % 6),
    delay: -(i % 5),
}));

const RED_DOTS = Array.from({ length: 8 }).map((_, i) => ({
    i,
    size: 24 + (i % 4),
    left: (i * 87) % 100,
    top: (i * 33) % 100,
    opacity: 0.18 + ((i % 5) * 0.03),
    dur: 4.5 + (i % 6),
    delay: -(i % 5),
}));

const CYAN_DOTS = Array.from({ length: 8 }).map((_, i) => ({
    i,
    size: 36 + (i % 4),
    left: (i * 41) % 100,
    top: (i * 12) % 100,
    opacity: 0.18 + ((i % 5) * 0.03),
    dur: 4.5 + (i % 6),
    delay: -(i % 5),
}));

function Particles() {
    return (
        <div className="pointer-events-none absolute inset-0 z-50">
            {WHITE_DOTS.map((d) => (
                <span
                    key={d.i}
                    className="absolute rounded-full bg-white/70"
                    style={{
                        width: `${d.size}px`,
                        height: `${d.size}px`,
                        left: `${d.left}%`,
                        top: `${d.top}%`,
                        opacity: d.opacity,
                        animation: `particle ${d.dur}s ease-in-out ${d.delay}s infinite`,
                        willChange: "transform, opacity",
                    }}
                />
            ))}

            {RED_DOTS.map((d) => (
                <span
                    key={"r" + d.i}
                    className="absolute rounded-full bg-red-500/60"
                    style={{
                        width: `${d.size}px`,
                        height: `${d.size}px`,
                        left: `${d.left}%`,
                        top: `${d.top}%`,
                        opacity: d.opacity,
                        animation: `particle ${d.dur}s ease-in-out ${d.delay}s infinite`,
                        willChange: "transform, opacity",
                    }}
                />
            ))}

            {CYAN_DOTS.map((d) => (
                <span
                    key={"c" + d.i}
                    className="absolute rounded-full bg-[#00E1D7]/50"
                    style={{
                        width: `${d.size}px`,
                        height: `${d.size}px`,
                        left: `${d.left}%`,
                        top: `${d.top}%`,
                        opacity: d.opacity,
                        animation: `particle ${d.dur}s ease-in-out ${d.delay}s infinite`,
                        willChange: "transform, opacity",
                    }}
                />
            ))}

            <style>{`
          @keyframes particle {
            0%,100% { transform: translate3d(0, 0, 0); opacity: .12; }
            50%     { transform: translate3d(10px, -14px, 0); opacity: .28; }
          }
        `}</style>
        </div>
    );
}

export default function HeroLoop() {
    return (
        <section className="relative h-screen w-full overflow-hidden">
            <Particles />
        </section>
    );
}
